import * as rudderanalytics from "rudder-sdk-js";

rudderanalytics.load(
  window.config.REACT_APP_RUDDERSTACK_WRITE_KEY,
  window.config.REACT_APP_RUDDERSTACK_DATA_PLANE_URL
);

rudderanalytics.ready(() => {
  console.log("rudderstack loaded successfully!");
});

export { rudderanalytics }
